
import React, {Component} from 'react';
import native from 'c-up-native';
import loading from 'c-up-loading';
import Video from '../component/video/index';
import Flv from '../component/video/flv';

let system = native.getSystem();

class VideoPlay extends Component {

    static defaultProps = {
        videoUrl: '',
        hostid: '',
        coverUrl: '',
        resourceDesp: '',
        onPlayStart() {}
    };

    constructor(props) {
        super(props);
        this.state = {
            playStatus: 0 // 0：未播放；1：播放中；2: 暂停；3播放结束
        }
    }
    createVideo() {
        let self = this;
        let resourceDesp = this.props.resourceDesp;

        if (resourceDesp) {
            resourceDesp =  JSON.parse(resourceDesp);
        }

        let source;

        try {
            source = JSON.parse(this.props.videoUrl)[0]
        } catch (error) {
            source = this.props.videoUrl
        }
        
        if (system == 'pc' && source.indexOf('.mp4') < 0) {
            var flv = this.flv = new Flv({
                wrap: '#videoWrap',
                source
            });

            flv.on('start', ()=>{ 
               let delay = 200;

                self.setState({
                    playStatus: 1
                });
                
                setTimeout(()=>{
                    loading.hide();
                    $(this.refs.avatar).addClass('hidden');
                    this.props.onPlayStart();
                }, delay);
            });

            flv.on('ended', function () {
                self.setState({
                    playStatus: 3
                });
                $.channel.emit('livingEnd');
            });

            flv.play();

        } else {
            
            
            var video = this.video = new Video({
                wrap: '#videoWrap',
                coverUrl: this.state.coverUrl,
                source
            });

            video.on('start', ($video)=>{ 
                if (resourceDesp && resourceDesp.height > resourceDesp.width) {
                    $video.css({
                        'object-fit': 'cover'
                    });
                }

                if (system == 'android') {
                    
                    self.setState({
                        playStatus: 1
                    });

                    setTimeout(()=>{
                        
                        loading.hide();
                        $(this.refs.avatar).addClass('hidden');
                        this.props.onPlayStart();
                    }, 500)
                } else {
                    self.setState({
                        playStatus: 1
                    });

                    setTimeout(()=>{
                        loading.hide();
                        $(this.refs.avatar).addClass('hidden');
                        this.props.onPlayStart();
                    }, 200);
                }
            });

            video.on('ended', function () {
                self.setState({
                    playStatus: 3
                });
                $.channel.emit('livingEnd');
            });

            video.on('pause', function () {
                self.setState({
                    playStatus: 2
                });
                $.channel.emit('livingPause');
            });

            video.on('androidWechatExitFullScreen', ()=>{
                if (this.state.playStatus !== 3) {
                    self.setState({
                        playStatus: 2
                    });
                }
                this.props.onAndroidWechatExitFullScreen();
            });

            video.on('androidWechatEnterFullScreen', ()=>{
                this.props.onAndroidWechatEnterFullScreen();
            });
        }
        
    }



    componentWillUnmount() {
        this.video && this.video.destroy();
        loading.hide();
    }

    pause=(e)=>{
        this.video && this.video.pause();
    }   

    // 必须通过手动点击才能加载视频资源？未知原因
    play = (e) => {
        loading.show();

        if (this.video) {
            if (this.state.playStatus !== 0) {
                this.setState({
                    playStatus: -1
                });
            }
            this.props.onPlayStart();
            this.video.play();     
            loading.hide();
        } else {
            this.createVideo();    
        }
    }
    render() {
        let {playStatus} = this.state;
        let $btn;
        
        switch(playStatus) {
            case 0: // 未播放
            case 2: // 暂停
                $btn = <img ref="btn" className="btn" onClick={this.play} src={require('../../images/play11.png')} />;
                break;
            case 3: 
                $btn = <img ref="btn" className="refresh" onClick={this.play} src={require('../../images/refresh.png')} />
                break;
        }

        return (
            <div>
                <div id="videoWrap" className="video-wrap"></div>
                <div className="poster" ref="poster">
                    {$btn}
                    <div
                        className="posterpic"
                        ref="avatar"
                        onClick={this.play}
                        style={{
                            height: document.documentElement.clientHeight + 'px',
                            backgroundImage: 'url(' + this.props.coverUrl + ')',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center center',
                            backgroundSize: 'cover'
                        }}
                    >
                    </div>
                </div>
            </div>
        );
    }

}

export default VideoPlay;



// WEBPACK FOOTER //
// ./js/videoplay/index.js